<template>
    <div v-if="dataIsVisible" class="c-input-cc">
        <PGTokenization
                :ref="id + '_tokenization'"
                :onTokenizationSuccess="afterTokenization"
                :onTokenizationError="onTokenizationError">
            <slot slot="body">
                <b-row>
                    <b-col lg="12" md="12" sm="12">
                        <InputText
                                :ref="id + '_holderName'"
                                :label="Core.Definition.getDefinition('Détenteur de la carte')"
                                v-model="dataHolderName"></InputText>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="12" md="12" sm="12">
                        <InputCCNumber
                                :ref="id + '_number'"
                                :label="Core.Definition.getDefinition('Numéro de la carte')"
                                v-model="dataNumber"></InputCCNumber>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="4" md="4" sm="12">
                        <InputCCExp
                                :ref="id + '_exp'"
                                :label="Core.Definition.getDefinition('Expiration (MM/AA)')"
                                v-model="dataExp"></InputCCExp>
                    </b-col>
                    <b-col lg="4" md="4" sm="12">
                        <InputMask
                                :ref="id + '_CVD'"
                                mask="###"
                                :label="Core.Definition.getDefinition('CVD')"
                                v-model="dataCVD"></InputMask>
                    </b-col>
                    <b-col lg="4" md="4" sm="12">
                        <CCBrands :class="'mt-4'"></CCBrands>
                    </b-col>
                </b-row>
            </slot>
        </PGTokenization>
        
    </div>

</template>

<script>
    import PGTokenization from './PGTokenization'
    import InputCCNumber from './InputCCNumber'
    import InputCCExp from './InputCCExp'
    import InputText from './InputText'
    import InputMask from './InputMask'
    import CCBrands from './CCBrands'
    export default {
        name: 'InputCC',
        components: {
            InputCCNumber,
            InputCCExp,
            InputText,
            CCBrands,
            PGTokenization,
            InputMask
        },
        props: {
            onTokenizationSuccess: {
                type: Function,
                default: function() {
                    return false
                }
            },
            onTokenizationError: {
                type: Function,
                default: function() {
                    return false
                }
            },
            value: {
                type: Object,
                default: function() {
                    return {
                        holderName: '',
                        number: '',
                        expMonth: '',
                        expYear: '',
                        CVD: '',
                        token: ''
                    }
                }
            },
            id: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            form: {
                type: Object,
                default: function() {return {}}
            },
            fieldRefs: {
                type: Array,
                default: function() { return [] }
            }
        },
        watch: {
            dataHolderName(val) {
                this.setValue()
            },
            dataNumber(val) {
                this.setValue()
            },
            dataExp(val) {
                this.setValue()
            },
            dataCVD(val) {
                this.setValue()
            },
            dataToken(val) {
                this.setValue()
            }
        },
        mounted() {
        },
        data: () => {
            return {
                Core: window.Core,
                dataIsVisible: true,
                dataHolderName: '',
                dataNumber: '',
                dataExp: '',
                dataCVD: '',
                dataToken: '',
                dataExpMonth: '',
                dataExpYear: ''
            }
        },
        computed: {
            isVisible: {
                set(val) {
                    this.dataIsVisible = val
                },
                get() {
                    return this.dataIsVisible
                }
            },
        },
        methods: {
            reset() {
                this.dataHolderName = ''
                this.dataNumber = ''
                this.dataExp = ''
                this.dataCVD = ''
                this.dataToken = ''
                this.dataExpMonth = ''
                this.dataExpYear = ''
            },
            setValue() {
                let exp = this.dataExp.split('/')
                let expMonth = exp[0]
                let expYear = exp[1]
                this.dataExpMonth = expMonth
                this.dataExpYear = expYear
                let value = {
                    holderName: this.dataHolderName,
                    number: this.dataNumber,
                    expMonth: expMonth,
                    expYear: expYear,
                    CVD: this.dataCVD,
                    token: this.dataToken
                }
                this.$emit('input', value)
            },
            getExp() {
                let exp = this.dataExp.split('/')
                let expMonth = exp[0]
                let expYear = exp[1]
                return {
                    expMonth: expMonth,
                    expYear: expYear
                }
            },
            getToken() {
                if (this.dataNumber !== '' && this.dataHolderName !== '' && this.dataExpYear !== '' && this.dataExpMonth !== '' && this.dataCVD !== ''){
                    this.$refs[this.id + '_tokenization'].request(this.dataNumber, this.dataHolderName, this.dataExpMonth, this.dataExpYear, this.dataCVD)
                } else {
                    this.onTokenizationError('', this.form, this.fieldRefs)
                }
            },
            afterTokenization(data) {
                if (data.token !== undefined) {
                    this.dataToken = data.token
                    this.onTokenizationSuccess(data.token, this.form.$model, this.fieldRefs)
                } else {
                    this.onTokenizationError(data, this.form, this.fieldRefs)
                }
            }
        }
    }
</script>